import { createContext, useState, ReactNode } from "react";

export type Language = "en" | "fr";

export interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<Language>(() => {
    // Detect browser language
    const browserLang = navigator.language.toLowerCase();
    // Set to 'fr' if browser language is French, otherwise default to 'en'
    return browserLang.startsWith("fr") ? "fr" : "en";
  });

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
